export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Clear-Gray-88efa7455edd6765eac7217b05380ed0.svg";